import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnouncement = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.44108 10.2081L8.86363 14.6667H5.94662L4.53614 10.6372M7.44108 10.2081C6.46903 10.3186 5.50303 10.49 4.53614 10.6372M7.44108 10.2081C9.25325 10.0022 11.0868 10.0685 12.8808 10.4054M4.53614 10.6372L3.44808 10.8029C2.09996 9.85213 1.62351 8.07399 2.31562 6.57651L5.42879 5.36022C7.34605 4.61117 9.12239 3.54404 10.6833 2.20442M12.8808 10.4054C12.9851 10.4656 13.0829 10.4862 13.1715 10.4625C13.7551 10.3061 13.7211 8.28712 13.0957 5.95293C12.4702 3.61875 11.4902 1.85327 10.9066 2.00963C10.818 2.03339 10.7436 2.10013 10.6833 2.20442M12.8808 10.4054C12.2984 10.0693 11.5129 8.49875 10.9825 6.51916C10.452 4.53957 10.347 2.78669 10.6833 2.20442",
		stroke: "#DC2626",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAnnouncement);
export default ForwardRef;
